import { RepliersListingCondoExposure } from './RepliersListingCondoExposure';

export enum DirtyRepliersListingCondoExposure {
  'NorthITSO' = 'North',
  'SouthITSO' = 'South',
  'EastITSO' = 'East',
  'WestITSO' = 'West',
}

export type UnsanitizedRepliersListingCondoExposure =
  | RepliersListingCondoExposure
  | DirtyRepliersListingCondoExposure;
